import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToastType } from "src/app/constants/toast-type";
import { MemberService } from "src/app/services/member.service";
import { Member, UpdateMemberProfile } from "src/app/models/member";
import { ToastService } from "src/app/services/toast.service";
import { MatDialog } from "@angular/material/dialog";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { DialogAccountDeleteComponent } from "../../shared/dialog/delete-account.component";

@Component({
    selector: 'mwp-profile-member',
    templateUrl: './member.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileMemberComponent implements OnInit {
    public displayForm: boolean;
    public member: Member;
    public apiUrl = ContentHeaderKey.ProfileMember;

    constructor(
        private memberService: MemberService,
        private toastService: ToastService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.loadForm();
    }

    public displaySaveWarning(): void {
        this.toastService.buildToastMessage(ToastType.warning, 'No Changes Found', 'Make necessary changes to the member and click save again!');;
    }

    public save(updateMemberProfile: UpdateMemberProfile): void {
        this.memberService.saveMemberProfile(updateMemberProfile).subscribe();
    }

    public deleteAccount(): void {
        this.dialog.open(DialogAccountDeleteComponent, {
            panelClass: 'mwp-modal-override-800'
        });
    }

    public reload(): void {
        this.loadForm();
    }

    private loadForm(): void {
        this.displayForm = false;
        this.memberService.getMemberProfile().subscribe((response: Member) => {
            this.member = response;
            this.displayForm = true;
        });
    }
}
